import { IDropdownOption } from "@fluentui/react/lib/Dropdown";

export const OPERATOR_LIST: IDropdownOption[] = [
  { key: `<=`, text: `≤` },
  { key: `<`, text: `<` },
  { key: `>=`, text: `≥` },
  { key: `>`, text: `>` },
  { key: `=`, text: `=` }
];

export const DEFAULT_OPERATOR = OPERATOR_LIST[0];
